import "./style.scss";

const ModalWarning = ({
  warningText,
  modalSubText,
  changeModal,
  modalValue,
  Image,
  buttonText,
  handleButton,
}) => {
  // modalValue - "modal-warning"

  return (
    <div className={`warning-container ${modalValue}`}>
      <div className="warning-content">
        <div className="warning-icon">
          <Image />
        </div>
        <div className="warning-text">
          <h3>{warningText}</h3>
        </div>
        <div className="warning-sub-text">
          <span>{modalSubText}</span>
        </div>
        <div className="warning-button">
          <div>
            <button
              onClick={() => {
                changeModal("");
                handleButton();
              }}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalWarning;
